import React, { FC } from 'react';

import { RibbonType } from 'common/contracts';

import { RibbonTextChip } from './RibbonTextChip';

interface IBadgeOverlayProps {
  ribbon?: RibbonType;
}

const OVERLAY_CLASSNAME =
  'pointer-events-none absolute left-3 top-3 z-[100]';

export const BadgeOverlay: FC<IBadgeOverlayProps> = ({
  ribbon
}): React.ReactElement | null => {
  if (ribbon?.imageUrl) {
    return (
      <div className={OVERLAY_CLASSNAME}>
        <img
          src={ribbon.imageUrl}
          alt="Selected ribbon badge"
          className="h-auto w-24 object-contain"
        />
      </div>
    );
  }

  if (ribbon?.text) {
    return (
      <div className={OVERLAY_CLASSNAME}>
        <RibbonTextChip ribbon={ribbon} />
      </div>
    );
  }

  return null;
};
